export const theme = {
	colors: {
		common: {
			textColor: "#FFF",
			textColorGold: "#DEC279",
			backgroundcolor: "#5C2121",
		},
		card: {
			primary: "#5C2121",
			linecolor: "#3B1616",
		},
		button: {
			primary: "#5C2121",
			secondary: "#3B1616",
			false: "#981919",
			true: "#236B11",
			answer: "transparent",
			hover: "#AC4949",
			falseHover: "#EC3333",
			trueHover: "#47BA2A",
			google: "#fff",
			facebook: "#4267B2",
		},
		input: {
			primary: "#D9D9D9",
			secondary: "#3B1616",
		},
		timer: {
			primary: "#D9D9D9",
			secondary: "#981919",
			text: "#DEC279",
		},
	},
	size: {
		mobile: {
			sm: 10,
			mds: 12,
			md: 14,
			mdl: 16,
			lg: 20,
			xl: 24,
			xxl: 26,
		},
		desktop: {
			sm: 16,
			mds: 20,
			md: 24,
			mdl: 32,
			lg: 36,
			xl: 40,
			xxl: 48,
		},
		common: {
			borderRadius: "20px",
		},
	},
	// weight: { //to chyba nie będzie działać, jak pobierałam czcionkę to tylko 400 było
	// 	light: 200,
	// 	regular: 400,
	// 	bold: 700,
	// },
};
